import React, {useEffect, useState} from "react";
import {currencyConverter, generate_token, serverLink} from "../../url";
import axios from "axios";
import {showAlert} from "../../common/sweetalert/sweetalert";
import {connect} from "react-redux";
import Loader from "../../common/loader";
import {toast} from "react-toastify";
import PatientAllergies from "../utils/patient-allergies";
function AllergyPopUp(props) {
    const { patientSerial, patientName, walletAmount, showAllergyPopUp, setShowAllergyPopUp, toggleAllergyPopUp, toggleAllergy} = props;
    const token = props.loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(false)

    useEffect(() => {
        // document.getElementById('open-now').click();
    }, []);


    return IsLoading ? <Loader/> : <>
        <div id={`${
            typeof props.id !== "undefined" ? props.id : "responsive-modal"
        }`} className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" inert style={{display: 'none'}}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header text-white" style={{backgroundColor: '#4b4949'}}>
                        <h2 className="modal-title" id="myLargeModalLabel">{props.title ?? ""}</h2>
                        <button type="button" className={`${
                            typeof props.close !== "undefined" ? props.close : "closeModal"
                        }`}  id={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`} data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div className="modal-body">
                        <PatientAllergies patientSerial={patientSerial} setShowAllergyPopUp={setShowAllergyPopUp} toggleAllergy={toggleAllergy} showAllergyPopUp={showAllergyPopUp} toggleAllergyPopUp={toggleAllergyPopUp} />
                    </div>
                </div>
            </div>
        </div>
    </>
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(AllergyPopUp);